import { useContext } from 'react';
import getConfig from 'next/config';
import { AuthContext } from './AuthContext.js';

const { backstageUri } = getConfig().publicRuntimeConfig;

export { AuthProvider } from './AuthProvider.jsx';

export function useAuth() {
  return useContext(AuthContext);
}

export function getSignInUrl({ redirect = '/' } = {}) {
  return `${backstageUri}/auth/tink/auth?redirect=${encodeURIComponent(
    redirect
  )}`;
}

export function getSignOutUrl({ redirect = '' } = {}) {
  return `${backstageUri}/auth/sign-out?redirect=${encodeURIComponent(
    redirect
  )}`;
}
